import * as React from 'react';
import { useTranslation } from 'react-i18next';
import './header.scss';
import Logo from '../../assets/images/logo.svg';

const Header = () => {
  const { t } = useTranslation('', { keyPrefix: 'PAGE_HEADER' });
  return (
    <header>
      <div className="header-left">
        <img src={Logo} alt="net2phone" />
        <h1>{t('TITLE')}</h1>
      </div>
    </header>
  );
};

export default Header;
